import { Svg, SvgProps } from "../Svg";

const LineChartLoaderSVG: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M30.9542 20.0094C30.2568 22.5237 28.9156 24.8125 27.063 26.65C25.2105 28.4874 22.9107 29.8098 20.3908 30.4866C17.8708 31.1634 15.218 31.1712 12.6941 30.5091C10.1703 29.8471 7.86277 28.5382 5.99949 26.7116C4.13622 24.8851 2.78162 22.6041 2.06949 20.0939C1.35735 17.5838 1.31231 14.9313 1.93881 12.3984C2.56531 9.86546 3.84168 7.53979 5.64187 5.65104C7.44206 3.76228 9.70379 2.37577 12.2037 1.62843"
        stroke="url(#paint0_angular_1322_28126)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <defs>
        <radialGradient
          id="paint0_angular_1322_28126"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.246 15.746) rotate(-54.7824) scale(15.8542 16.0893)"
        >
          <stop offset="0.0155" stopColor="#FD6422" />
          <stop offset="0.2601" stopColor="#FC194A" />
          <stop offset="0.6054" stopColor="#FC125F" />
          <stop offset="1" stopColor="#9B2AA6" />
        </radialGradient>
      </defs>
    </Svg>
  );
};

export default LineChartLoaderSVG;
